// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__ds3pC","active":"Pagination_active__THnKb"};